<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-progress-circular v-show="approveloading || declineloading" color="secondary"
                class="accent--text logoutbtn" size="25"
                           indeterminate></v-progress-circular>
      <v-spacer></v-spacer>
      <v-row no-gutters justify="space-around" class="mb-4 mt-4">
        <v-col v-if="canUploadLimits" class="d-flex justify-center">
          <v-btn color="#3386FF" @click="downloadLimitTemplate" class="white--text parchmentbtn">Download Cherry
            Template
          </v-btn>
        </v-col>
        <v-col v-if="canUploadLimits" class="d-flex justify-center">
          <v-btn color="#7BC243" @click="uploadFarmersDialog" class="white--text cataloguebtn">Upload Cherry Records
          </v-btn>
        </v-col>
		<!-- <v-col v-if="canUploadLimits" class="d-flex justify-center">
          <v-btn color="#7BC243" @click="createCherrysRecordDialog" class="white--text cataloguebtn">Cherry Single Creation
          </v-btn>
        </v-col> -->
      </v-row>
    </v-row>

    <v-layout>
      <v-flex xs12>
        <div :class="paginatedFiles.length === 7 ? 'limits_box' : 'limits_box_empty'">
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> Uploaded Cherry Records </span>
              </v-flex>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
            </v-layout>
            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">File Name</th>
                <th scope="col">No of Records</th>
                <th scope="col">Uploaded By</th>
                <th scope="col">Status</th>
                <th scope="col">Date</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="file in filteredList" v-bind:key="file.id">
                <td>{{ file.fileName }}</td>
                <td>{{ file.numberOfLots }}</td>
                <td>{{ file.createdBy }}</td>
                <td>{{ file.status !== null ? file.status.statusName : '' }}</td>
                <td>{{ file.created | prettyDate }}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        v-on="on"
                        text
                        icon
                        class="actions"
                      >
                        <v-icon class="secondary--text"> more_horiz</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-bind:to="'/farmers/limits/' +  file.id  + '/checkoffSettlementDetails'">
                        <v-list-item-title> View</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="canBeApproved(file)" @click="confirmAction(file, 'approve')">
                        <v-list-item-title> Approve</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="canBeDeclined(file)" @click="confirmAction(file, 'decline')">
                        <v-list-item-title> Decline</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="canBeApprovedKPCU(file)" @click="confirmAction(file, 'approve')">
                        <v-list-item-title> Approve</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="canBeDeclinedKPCU(file)" @click="confirmAction(file, 'decline')">
                        <v-list-item-title> Decline</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="downloadLimits(file)">
                        <v-list-item-title> Download</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
      <v-dialog v-model="confirmDialog" max-width="500">
        <v-card>
          <v-card-title class="headline accent--text text-capitalize">{{ this.action }} Limits</v-card-title>
          <v-card-text>
            <v-flex xs12>
              <p class="font-weight-regular subheading"> {{ confirmMessage }} </p>
            </v-flex>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="confirmDialog = false"
              class="font-weight-bold"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              class="white--text logoutbtn"
              @click="approveOrDecline(confirmFile)"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="uploadFileDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline accent--text">Upload Cherry Records</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <label>File
                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" required/>
              </label>
              <!--         <v-checkbox v-if="isAKPCUUser === false" class="mt-4" v-model="shareDataCheckbox" label="Share data with New KPCU?"-->
              <!--      ></v-checkbox>-->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="cancelFileUpload">Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="uploadLimit" :loading="loading">Upload</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
	  <v-dialog v-model="createCherryRecordDialog" persistent max-width="800">
        <v-card>
          <v-card-title class="headline accent--text">Create Cherry Record</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
				<v-row>
              <v-col cols="12"  md="6">
                <v-text-field
				v-model="idNumber"
                  label="ID Number"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12"  md="6">
                <v-text-field
				v-model="fullName"
                  label="FULL NAME"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
			<v-row>
              <v-col cols="12"  md="6">
                <v-text-field
				v-model="memberNumber"
                  label="MEMBER NUMBER"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12"  md="6">
                <v-autocomplete name="benefactor" v-model="charge.growerCode" :items="benefactors"
					  item-text="organisationName" item-value='organisationCode' @input="validateSelectedItem"
					  label="Grower" v-if="benefactorsField" required>
					  >
					</v-autocomplete>
              </v-col>
            </v-row>
			<v-row>
              <v-col cols="12"  md="6">
                <v-text-field
                  label="PRODUCE NAME"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12"  md="6">
                <v-text-field
                  label="CURRENT DELIVERY"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="cancelCherrysRecordDialog">Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="uploadLimit" :loading="loading">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import { mapState } from 'vuex'
import { Common } from '@/components/views/file/common'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			previewItems: [],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			totalFiles: 0,
			pagination: { sortBy: 'id', descending: true },
			loading: false,
			search: '',
			expand: false,
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			benefactors: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			uploadFileDialog: false,
			createCherryRecordDialog: false,
			shareDataCheckbox: false,
			organisationType: '',
			organisationId: ''
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getUploadedFiles()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState([
			'userInfo', 'user'
		]),
		canUploadLimits: function () {
			return this.hasPerm('CAN_UPLOAD_LIMITS')
		},
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => {
					return file.fileName.toLowerCase().includes(this.search.toLowerCase())
				})
			}
		},
		isAKPCUUser () {
			return this.user.organisation.organisationType.name === 'KPCU'
		}
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		confirmAction (item, action) {
			this.confirmFile = item
			this.confirmDialog = true
			this.action = action
			if (action === 'approve') {
				this.confirmMessage = 'Approve Cherry Details File ' + item.fileName + ' ?'
			} else if (action === 'decline') {
				this.confirmMessage = 'Decline Cherry Details File ' + item.fileName + ' ?'
			} else {
				console.error(action + 'Action not supported')
			}
		},
		canBeApproved (item) {
			if (item.status === null) {
				return false
			}
			return (item.status.id === 19 || item.status.id === 18) && this.hasPerm('CAN_APPROVE_LIMITS')
		},
		canBeApprovedKPCU (item) {
			if (item.status === null) {
				return false
			}
			return (item.status.id === 17) && this.hasPerm('CAN_APPROVE_LIMITS') && this.user.organisation.organisationType.id === 10
		},
		canBeDeclined (item) {
			if (item.status === null) {
				return false
			}
			return (item.status.id === 19 || item.status.id === 18) && this.hasPerm('CAN_APPROVE_LIMITS')
		},
		canBeDeclinedKPCU (item) {
			if (item.status === null) {
				return false
			}
			return (item.status.id === 17) && this.hasPerm('CAN_APPROVE_LIMITS') && this.user.organisation.organisationType.id === 10
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		approveOrDecline (item) {
			if (this.action === 'approve') {
				this.approve(item)
			} else if (this.action === 'decline') {
				this.decline(item)
			} else {
				console.error('Function not supported')
			}
		},
		approve (item) {
			this.approveloading = true
			const url = config.serverURI + '/upload/cherry/approve_limit/' + this.organisationId
			console.log('calling ' + url)
			const docData = item
			axios({ url: url, method: 'POST', responseType: 'blob', data: docData })
				.then(response => {
					this.approveloading = false
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.message = 'Success'
					this.getUploadedFiles()
				})
				.catch(error => {
					if (error.response.status === 424) {
						this.message = 'Failed:: review  downloaded Limit file for errors'
						const url = window.URL.createObjectURL(new Blob([error.response.data], { type: 'application/vnd.ms-excel' }))
						const link = document.createElement('a')
						link.href = url
						const itemFileName = 'File_Approved_With_Error_' + docData.fileName
						link.setAttribute('download', itemFileName)
						document.body.appendChild(link)
						link.click()
					} else {
						Common.blobToJson(error.response.data)
							.then(jsonData => {
								this.message = typeof jsonData.message !== 'undefined' ? jsonData.message : error.response.status + ' Request failed'
							})
							.catch(error => {
								console.error('Error:', error)
								this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status + ': Error occurred'
							})
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveloading = false
				})

			this.confirmDialog = false
		},
		decline (item) {
			this.declineloading = true
			const url = config.serverURI + '/upload/cherry/decline_limit'
			const document = item
			axios.post(url, document)
				.then(response => {
					this.declineloading = false
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.getUploadedFiles()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			this.confirmDialog = false
		},
		getUploadedFiles () {
			var url = config.serverURI + '/upload/cherry/limitFiles/' + this.organisationId
			axios.get(url)
				.then(response => {
					this.files = response.data
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
				})
			return this.files
		},
		uploadFarmersDialog () {
			this.uploadFileDialog = true
		},
		createCherrysRecordDialog(){
			this.createCherryRecordDialog = true
		},
		cancelCherrysRecordDialog () {
			this.createCherryRecordDialog = false
			this.$refs.form.reset()
			this.$refs.file.value = null
		},
		uploadLimit () {
			if (this.$refs.form.validate()) {
				this.loading = true
				const url = config.serverURI + '/upload/cherry/delivery/' + this.organisationId
				const formData = new FormData()
				formData.append('file', this.file)
				formData.append('shareData', this.shareDataCheckbox)
				axios({ url: url, method: 'POST', responseType: 'blob', data: formData })
					.then(response => {
						this.uploadFileDialog = false
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Success'
						this.getUploadedFiles()
					})
					.catch(error => {
						this.shareDataCheckbox = false

						if (error.response.status === 424) {
							this.message = 'Failed:: review  downloaded lIMIT FILE for errors'
							const url = window.URL.createObjectURL(new Blob([error.response.data], { type: 'application/vnd.ms-excel' }))
							const link = document.createElement('a')
							link.href = url
							const itemFileName = 'File_With_Error_' + this.file.name
							link.setAttribute('download', itemFileName)
							document.body.appendChild(link)
							link.click()
						} else {
							Common.blobToJson(error.response.data)
								.then(jsonData => {
									this.message = typeof jsonData.message !== 'undefined' ? jsonData.message : error.response.status + ' Request failed'
								})
								.catch(error => {
									console.error('Error:', error)
									this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status + ': Error occurred'
								})
						}
						this.snackbar = true
						this.snackbarColor = 'error'
						this.uploadFileDialog = false
					})
				this.handleFileUpload()
			}
		},
		cancelFileUpload () {
			this.uploadFileDialog = false
			this.$refs.form.reset()
			this.$refs.file.value = null
		},

		downloadLimitTemplate () {
			const url = config.serverURI + '/files/downloads?filename=loanlimit'

			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					// this.downloadFileDialog = false

					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = 'loanlimit_sample.xlsx'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()

					this.message = response.message
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)

					Common.blobToJson(error.response.data)
						.then(jsonData => {
							this.message = typeof jsonData.message !== 'undefined' ? jsonData.message : error.response.status + ' Request failed'
						})
						.catch(error => {
							console.error('Error:', error)
							this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status + ': Error occurred'
						})
					// this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					// this.downloadFileDialog = false
				})
		},
		downloadLimits (item) {
			const url = config.serverURI + '/upload/cherry/' + item.id + '/download/'
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.fileName
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		}
	}
}

</script>
<style>
.limits_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.limits_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

/*.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}*/

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}
</style>
